import ReactDOM from 'react-dom/client';
import App from './pages/App';
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import Edit from './pages/Edit';
import Menu from './pages/Menu';
import Checkout from './pages/Checkout';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Routes>
    <Route path='/' Component={App}/>
    <Route path='/signin' Component={Signin}/>
    <Route path='/signup' Component={Signup}/>
    <Route path="/checkout" element={<Checkout/>}/>
    <Route path='/dash' Component={Dashboard}/>
    <Route path='/edit' Component={Edit}/>
    <Route path='/:menuid' Component={Menu}/>
    <Route path="/analytics" element={<Analytics />} />
    <Route path="/settings" element={<Settings/>}/>
  </Routes> 
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
